export enum TeacherFileItemAction {
  Edit = 'edit',
  Disable = 'disable',
  SendInvitation = 'sendInvitation',
}
